import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

class RedeemIcon extends React.PureComponent {
  render() {
    return (
      <SvgIcon {...this.props}>
        <path d="M22,6 L17.82,6 C17.93,5.69 18,5.35 18,5 C18,3.34 16.66,2 15,2 C13.95,2 13.04,2.54 12.5,3.35 L12,4.02 L11.5,3.34 C10.96,2.54 10.05,2 9,2 C7.34,2 6,3.34 6,5 C6,5.35 6.07,5.69 6.18,6 L2,6 L2,21 L22,21 L22,6 Z M15,4 C15.55,4 16,4.45 16,5 C16,5.55 15.55,6 15,6 C14.45,6 14,5.55 14,5 C14,4.45 14.45,4 15,4 Z M9,4 C9.55,4 10,4.45 10,5 C10,5.55 9.55,6 9,6 C8.45,6 8,5.55 8,5 C8,4.45 8.45,4 9,4 Z M20,19 L4,19 L4,17 L20,17 L20,19 Z M20,14 L4,14 L4,8 L9.08,8 L7,10.83 L8.62,12 L12,7.4 L15.38,12 L17,10.83 L14.92,8 L20,8 L20,14 Z" />
      </SvgIcon>
    )
  }
}

export default RedeemIcon



// WEBPACK FOOTER //
// ./src/js/components/Mui/RedeemIcon.js